import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionOngoingPurchasePremiumDeselect, actionOngoingPurchaseStandardDeselect, } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionNotEnoughResourceBuyWithGoldComplete, TypeActionNotEnoughResource, } from "../actionNotEnoughResource";
export var epicNotEnoughResourceBuyWithGoldConfirmed = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldConfirmed), switchMap(function (action) {
        var state = state$.value;
        var missingResources = action.missingResources;
        var playerId = state.playerInfo.playerId;
        return deps
            .netSend({
            id: CommandCode.BuyProductsGold,
            props: {
                items: missingResources,
                playerId: playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            var actions = [
                actionModalClose(IdModal.NotEnoughResource),
                actionOngoingPurchaseStandardDeselect(),
                actionOngoingPurchasePremiumDeselect(),
            ];
            actions.push(actionInventoryInfoRemoveResource(res.cost), actionNotEnoughResourceBuyWithGoldComplete(true));
            return from(actions);
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/epics/epicNotEnoughResourceBuyWithGoldConfirmed.ts
// module id = 2023
// module chunks = 3